import React, { forwardRef } from 'react';
import ImageBackground from "react-native-web/dist/exports/ImageBackground";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import { variantProp } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const inactiveBackground = `%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='24'%3E%3Cdefs%3E%3Cpattern id='DisabledProgress7' patternUnits='userSpaceOnUse' width='8' height='8'%3E%3Crect width='8' height='8' fill='%23B2B9BF'%3E%3C/rect%3E%3Ccircle cx='4' cy='4' r='2' fill='%23676E73' stroke='%23676E73' stroke-width='0'%3E%3C/circle%3E%3Ccircle cx='0' cy='0' r='2' fill='%23676E73' stroke='%23676E73' stroke-width='0'%3E%3C/circle%3E%3Ccircle cx='0' cy='8' r='2' fill='%23676E73' stroke='%23676E73' stroke-width='0'%3E%3C/circle%3E%3Ccircle cx='8' cy='0' r='2' fill='%23676E73' stroke='%23676E73' stroke-width='0'%3E%3C/circle%3E%3Ccircle cx='8' cy='8' r='2' fill='%23676E73' stroke='%23676E73' stroke-width='0'%3E%3C/circle%3E%3C/pattern%3E%3C/defs%3E%3Cpath d='M 0 0 L 0 140 L 2000 2000 L 2000 0 Z' style='fill: url(&quot;%23DisabledProgress7&quot;);'%3E%3C/path%3E%3C/svg%3E`;
const negativeBackground = `%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='24'%3E%3Cdefs%3E%3Cpattern id='NegativeProgress6' patternUnits='userSpaceOnUse' width='8' height='8'%3E%3Crect width='8' height='8' fill='%23C12335'%3E%3C/rect%3E%3Cpath d='M 0,8 l 8,-8 M -2,2 l 4,-4 M 6,10 l 4,-4' stroke-width='2' shape-rendering='auto' stroke='%23e7adb4' stroke-linecap='square'%3E%3C/path%3E%3C/pattern%3E%3C/defs%3E%3Cpath d='M 0 0 L 0 140 L 2000 2000 L 2000 0 Z' style='fill: url(&quot;%23NegativeProgress6&quot;);'%3E%3C/path%3E%3C/svg%3E`;
const ProgressBarBackground = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    variant
  } = _ref;
  let source = null;

  if (variant !== null && variant !== void 0 && variant.inactive) {
    source = inactiveBackground;
  } else if (variant !== null && variant !== void 0 && variant.negative) {
    source = negativeBackground;
  } else {
    return null;
  }

  return /*#__PURE__*/_jsx(ImageBackground, {
    ref: ref,
    source: {
      uri: `data:image/svg+xml,${source}`
    },
    style: staticStyles.imageBackground
  });
});
ProgressBarBackground.displayName = 'ProgressBarBackground';
ProgressBarBackground.propTypes = {
  /**
   * Progress bar variant.
   */
  variant: variantProp.propType
};
export default ProgressBarBackground;
const staticStyles = StyleSheet.create({
  imageBackground: {
    height: '100%'
  }
});